import { SafetyTag } from '@/types/object'
import { ThreatTag } from '@/services/threat-tag.service'

export type PropsTag = TagWithLevel[] | String[] | TagWithLevel | String

export interface TagWithLevel extends Partial<SafetyTag> {
  level?: number
}

export interface TagShow extends Partial<TagWithLevel & ThreatTag> {
  color: string
  icon: string
  title: string
  /** 威胁标签描述（译文），来自 `describeI18nKey` 的 `t()` 结果 */
  describe?: string
  bgColor: string
  type: string
  name:string
}

/** 安全标签类型对后端的映射 */
export enum SafetyTagType {
  /** 威胁类型 */
  threatType = 'threat_type',
  /** 攻击组织 */
  attackGroup = 'attack_group',
  /** 病毒家族 */
  malwareFamily = 'malware_family',
  /** 漏洞id */
  vulnerabilityId = 'vulnerability_id',
  /** basicInfo */
  basicInfo = 'basic_info',
  /** 未知 */
  unknown = 'unknown',
}

/** 安全标签类型对后端的反向映射 */
export enum SafetyTagTypeReverse {
  /** 威胁类型 */
  threat_type = 'threatType',
  /** 攻击组织 */
  attack_group = 'attackGroup',
  /** 病毒家族 */
  malware_family = 'malwareFamily',
  /** 漏洞id */
  vulnerability_id = 'vulnerabilityId',
  /** basicInfo */
  basic_info = 'basicInfo',
  /** 未知 */
  unknown = 'unknown',
}

/** 安全标签类型字体色 */
export enum SafetyTagTypeColor {
  /** 威胁类型 */
  threatType = '',
  /** 攻击组织 */
  attackGroup = '#E54545', /* dm-keep：高危红语义色 */
  /** 病毒家族 */
  malwareFamily = '#E54545', /* dm-keep：高危红语义色 */
  /** 漏洞id */
  vulnerabilityId = '#E54545', /* dm-keep：高危红语义色 */
  /** basicInfo */
  basicInfo = '#4AAE75', /* dm-keep：正常绿语义色 */
  /** 未知 */
  unknown = 'var(--cm-color-text-regular)',
}

/** 安全标签类型图标 */
export const SafetyTagTypeIcon = {
  /** 威胁类型 */
  threatType: '',
  /** 攻击组织 */
  attackGroup: 'components/safety-tags/_images/attack-group',
  /** 病毒家族 */
  malwareFamily: 'components/safety-tags/_images/malware-family',
  /** 漏洞id */
  vulnerabilityId: 'components/safety-tags/_images/vulnerability-id',
  /** basicInfo */
  basicInfo: 'components/safety-tags/_images/basic-info',
  /** 未知 */
  unknown: 'components/safety-tags/_images/unknow',
}

export const ThreatTagIcon = {
  /** 低危 */
  low: 'components/safety-tags/_images/threat-low',
  /** 中危 */
  medium: 'components/safety-tags/_images/threat-middle',
  /** 高危 */
  high: 'components/safety-tags/_images/threat-high',
}
